import React, { useState, useEffect } from 'react';
import { Avatar, Box, Button, Checkbox, Stack, Typography } from '@mui/material';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import palette from '../assets/sass/palette.scss';
import { format } from 'date-fns';
import { useAuth } from '../contexts/AuthContext';
import { useGameUtils } from '../utilities/GameUtils';
import { doc, updateDoc } from 'firebase/firestore';
import { useFirebase } from '../contexts/FirebaseContext';

const GameDatePoll = ({ gameData, onVote, onConfirm, usersWithPhotoURL, onDecline }) => {
  // console.log(gameData);
  const [acceptedDates, setAcceptedDates] = useState([]);
  const [pendingVotes, setPendingVotes] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { currentUser } = useAuth();
  const { acceptInvitation } = useGameUtils();
  const { db } = useFirebase();
  useEffect(() => {
    if (gameData?.dateTimeOptions && currentUser?.uid) {
      console.log('Debug - Full gameData:', gameData);
      console.log('Debug - dateTimeOptions:', gameData.dateTimeOptions);
      console.log('Debug - currentUser:', currentUser);

      const initialAcceptedDates = {};
      const initialPendingVotes = {};
      gameData.dateTimeOptions.forEach((dt) => {
        console.log('Debug - dateTimeOption:', dt);
        console.log('Debug - acceptedBy:', dt.acceptedBy);
        const isAccepted = dt.acceptedBy?.some(
          (accepted) => accepted.uid === currentUser.uid || accepted === currentUser.uid
        );
        console.log('Debug - isAccepted:', isAccepted, 'for user:', currentUser.uid);
        initialAcceptedDates[dt.id] = isAccepted;
        // Initialize pending votes with current accepted state
        initialPendingVotes[dt.id] = isAccepted;
      });
      console.log('Debug - final initialAcceptedDates:', initialAcceptedDates);
      setAcceptedDates(initialAcceptedDates);
      setPendingVotes(initialPendingVotes);
    }
  }, [gameData, currentUser]);

  const howManyVotes = (dt) => {
    return dt.acceptedBy.length;
  };

  const pollEnabled = () => {
    return true;
  };

  const outputSelectedDate = (date) => {
    if (date && date.toDate) {
      return format(date.toDate(), 'EEEE d MMM');
    }
    return 'TDB';
  };

  const outputSelectedTime = (date) => {
    if (date && date.toDate) {
      return format(date.toDate(), 'h:mmaaa');
    }
    return 'TBD';
  };
  const getUserPhotoURL = (uid) => {
    const user = usersWithPhotoURL?.find((user) => user?.uid === uid || user?.user === uid);
    return user ? user?.photoURL : null;
  };

  const getUserInitial = (uid) => {
    const user = usersWithPhotoURL?.find((user) => user?.uid === uid || user?.user === uid);
    return user ? user?.initial : '';
  };

  const hasUserSelectedDate = (idx) => {
    console.log('Debug - hasUserSelectedDate check:', {
      idx,
      pendingVotes,
      value: pendingVotes[idx],
    });
    // Show pending votes while editing, otherwise show accepted dates
    return pendingVotes[idx] || false;
  };

  const handleSelectedDateOption = (event) => {
    const idx = event.target.value;
    // Only update pending votes, don't submit immediately
    const newPendingVotes = { ...pendingVotes };
    newPendingVotes[idx] = !newPendingVotes[idx];
    setPendingVotes(newPendingVotes);
  };

  const handleSubmitVote = async () => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    try {
      const dates = [];
      Object.entries(pendingVotes || {}).forEach(([idx, isAccepted]) => {
        if (isAccepted) dates.push(parseInt(idx));
      });
      console.log('sefton: dates', gameData.id, currentUser.uid, dates);
      await acceptInvitation(gameData.id, currentUser.uid, dates);
      // Remove the current user from the declinedBy array on the game document
      const gameRef = doc(db, 'games', gameData.id);
      const updatedDeclinedBy = (gameData.declinedBy || []).filter((uid) => uid !== currentUser.uid);
      await updateDoc(gameRef, {
        declinedBy: updatedDeclinedBy,
      });
      
      // Update acceptedDates to match pendingVotes after successful submission
      setAcceptedDates(pendingVotes);
      
      if (onVote) {
        console.log('sefton: onVote', dates);
        setTimeout(() => {
          onVote(dates);
        }, 1000);
      }
    } catch (error) {
      console.error('Error submitting vote:', error);
      // Reset pending votes on error
      setPendingVotes(acceptedDates);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeclineEvent = async () => {
    if (isSubmitting || !onDecline) return;
    
    setIsSubmitting(true);
    try {
      // Add the current user to the declinedBy array on the game document
      const gameRef = doc(db, 'games', gameData.id);
      await updateDoc(gameRef, {
        declinedBy: [...(gameData.declinedBy || []), currentUser.uid],
      });

      // Clear all votes if user had any
      const clearedVotes = {};
      Object.keys(pendingVotes).forEach(key => {
        clearedVotes[key] = false;
      });
      setPendingVotes(clearedVotes);
      setAcceptedDates(clearedVotes);
      
      // Remove user from all date acceptances
      const updatedDateTimeOptions = gameData.dateTimeOptions.map((dt) => {
        return {
          ...dt,
          acceptedBy: dt.acceptedBy.filter((user) => user.uid !== currentUser.uid),
        };
      });
      
      await updateDoc(gameRef, {
        dateTimeOptions: updatedDateTimeOptions,
      });
      
      if (onDecline) {
        onDecline();
      }
    } catch (error) {
      console.error('Error declining event:', error);
    } finally {
      setIsSubmitting(false);
    }
  };


  // Check if votes have changed from original
  const hasVotesChanged = () => {
    return Object.keys(pendingVotes).some(key => pendingVotes[key] !== acceptedDates[key]);
  };

  console.log('acceptedDates', acceptedDates, 'pendingVotes', pendingVotes);

  return (
    <Stack
      spacing={3}
      sx={{ paddingTop: 3, width: '100%', alignItems: 'center' }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={3}
        sx={{ width: '100%', alignItems: 'stretch' }}
      >
        {(gameData.dateTimeOptions || []).map((dt) => (
          <Box
            key={dt.id}
            sx={{
              backgroundColor: hasUserSelectedDate(dt.id) ? palette.lime : palette.white,
              borderRadius: '24px',
              padding: 2,
              width: '100%',
              maxWidth: '350px',
              flexGrow: 1,
            }}
          >
            <Typography variant="moduleHeader">{outputSelectedDate(dt.option)}</Typography>
            <Typography vairant="small">{outputSelectedTime(dt.option)}</Typography>
            <Stack direction="row">
              {(dt.acceptedBy || []).map((vote, index) => {
              const initial = getUserInitial(vote?.uid);
              if (getUserPhotoURL(vote?.uid)) {
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar
                      key={index}
                      alt={vote.userName || vote.userId}
                      sx={{ bgcolor: index % 2 === 0 ? '#E9FFEA' : '#F9EDFF' }}
                      src={getUserPhotoURL(vote?.uid)}
                    />
                  </Box>
                );
              }
              return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginLeft: -1 }}>
                  <Avatar
                    key={index}
                    alt={vote.userName || vote.userId}
                    sx={{ bgcolor: index % 2 === 0 ? '#E9FFEA' : '#F9EDFF' }}
                  >
                    <Typography
                      variant="factorA"
                      color="primary"
                      component="small"
                      sx={{ color: '#4C4C4C' }}
                    >
                      {initial}
                    </Typography>
                  </Avatar>
                </Box>
              );
            })}
            {!dt.acceptedBy.length && <Avatar sx={{ opacity: 0 }} />}
          </Stack>
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <Typography>
              {howManyVotes(dt)} {howManyVotes(dt) === 1 ? 'Vote' : 'Votes'}
            </Typography>
            {currentUser ? (
            <Checkbox
              disabled={!pollEnabled()}
              value={dt.id}
              checked={hasUserSelectedDate(dt.id)}
              onChange={handleSelectedDateOption}
              icon={<CheckBoxOutlineBlankOutlinedIcon />}
              checkedIcon={<CheckBoxOutlinedIcon />}
              variant="bigCheckbox"
              sx={{ color: palette.secondary, padding: 0 }}
              />
            ) : (
              <Typography>
                Sign in to vote
              </Typography>
            )}
          </Stack>
        </Box>
        ))}
      </Stack>
      {currentUser && (
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          sx={{ width: '100%', maxWidth: '700px', mt: 2 }}
        >
          <Button
            variant="contained"
            onClick={handleSubmitVote}
            disabled={isSubmitting || !hasVotesChanged()}
            sx={{
              flex: 1,
              backgroundColor: 'rgb(171, 232, 50)', // Green for visibility on purple background
              color: 'black', // Black text for legibility on green
              fontWeight: 600,
              height: '48px',
              border: 'none',
              '&:hover': {
                backgroundColor: 'rgb(150, 210, 40)', // Slightly darker green on hover
                color: 'black',
              },
              '&:disabled': {
                backgroundColor: '#E3DCE7',
                color: 'rgba(0, 0, 0, 0.4)', // Dimmed black text when disabled
              },
            }}
          >
            {isSubmitting ? 'Submitting...' : 'Vote'}
          </Button>
          <Button
            variant="contained"
            onClick={handleDeclineEvent}
            disabled={isSubmitting}
            sx={{
              flex: 1,
              backgroundColor: 'white',
              color: 'black',
              fontWeight: 600,
              height: '48px',
              border: '1px solid #E3DCE7',
              '&:hover': {
                backgroundColor: '#F5F5F5',
                border: '1px solid #D1D1D1',
              },
              '&:disabled': {
                backgroundColor: '#F8F8F8',
                color: 'rgba(0, 0, 0, 0.4)',
                border: '1px solid #E3DCE7',
              },
            }}
          >
            🚫 Decline Event
          </Button>
        </Stack>
      )}
    </Stack>
  );
};

export default GameDatePoll;
